export const isValidUrl = (url: string): boolean => {
  // Fallback for browsers that don't support URL.canParse (iOS 16 Safari)
  if (typeof URL.canParse === 'function') {
    return URL.canParse(url)
  }

  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}
